import { Icon } from "@chakra-ui/icons";

interface Props {
  color?: string;
  boxSize?: string;
}
export const VisaSmall = (props: Props) => (
  <Icon viewBox="0 0 34 24" {...props}>
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H30C32.2091 0 34 1.79086 34 4V20C34 22.2091 32.2091 24 30 24H4C1.79086 24 0 22.2091 0 20V4Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7502 15.8582H8.6905L7.14594 9.79237C7.07263 9.51334 6.91697 9.26667 6.688 9.1504C6.11658 8.85823 5.4869 8.62571 4.79999 8.50843V8.2749H8.11807C8.57601 8.2749 8.91947 8.62571 8.97671 9.03313L9.77811 13.4086L11.8368 8.2749H13.8393L10.7502 15.8582ZM14.9842 15.8582H13.039L14.6408 8.2749H16.586L14.9842 15.8582ZM19.1027 10.3757C19.1599 9.96728 19.5034 9.73374 19.9041 9.73374C20.5338 9.67511 21.2197 9.79238 21.7921 10.0835L22.1356 8.45081C21.5631 8.21727 20.9335 8.1 20.362 8.1C18.474 8.1 17.1002 9.15041 17.1002 10.6082C17.1002 11.7173 18.0733 12.2996 18.7602 12.6504C19.5034 13.0002 19.7896 13.2338 19.7324 13.5835C19.7324 14.1082 19.1599 14.3418 18.5885 14.3418C17.9016 14.3418 17.2147 14.1669 16.586 13.8747L16.2426 15.5085C16.9295 15.7996 17.6726 15.9169 18.3595 15.9169C20.4765 15.9745 21.7921 14.9251 21.7921 13.35C21.7921 11.3665 19.1027 11.2502 19.1027 10.3757ZM28.6 15.8582L27.0554 8.2749H25.3964C25.0529 8.2749 24.7095 8.50843 24.595 8.85823L21.7349 15.8582H23.7374L24.137 14.7502H26.5975L26.8265 15.8582H28.6ZM25.6826 10.3171L26.254 13.1751H24.6522L25.6826 10.3171Z"
      fill="#172B85"
    />
    <path
      d="M4 1H30V-1H4V1ZM33 4V20H35V4H33ZM30 23H4V25H30V23ZM1 20V4H-1V20H1ZM4 23C2.34315 23 1 21.6569 1 20H-1C-1 22.7614 1.23858 25 4 25V23ZM33 20C33 21.6569 31.6569 23 30 23V25C32.7614 25 35 22.7614 35 20H33ZM30 1C31.6569 1 33 2.34315 33 4H35C35 1.23858 32.7614 -1 30 -1V1ZM4 -1C1.23858 -1 -1 1.23858 -1 4H1C1 2.34315 2.34315 1 4 1V-1Z"
      fill="#F3F2F2"
    />
  </Icon>
);

export default VisaSmall;
